import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (id) {
  const { exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'DELETE_CRAFT_TEMPLATE',
    method: 'DELETE',
  });

  useEffect(() => {
    if (id){
      exec({
        url: `/api/craft/templates/${id}`,
      });
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return [exec,isRequestSuccessed];
});
